import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type UserModel from './user.ts';
import type UserRelationshipModel from './user-relationship.ts';
import type CompanyModel from './company.ts';
import type EmployeeModel from './employee.ts';

export default class UserRoleModel extends Model {
  @attr declare roleType: string;
  @attr declare isActive: boolean;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: 'roles' })
  declare user: UserModel;

  @hasMany('user-relationship', { async: false, inverse: 'role' })
  declare relationships: UserRelationshipModel[];

  // For COMPANY type roles (jurisdiction), the Company record associated via user_role_id
  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel | null;

  // For EMPLOYEE type roles, the Employee record associated via user_role_id
  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel | null;

  [Type] = 'user-role' as const;
}
